<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-6">
        <ArtistSelect class="artist-selection" @memberChangeEvent="getArtistInfo" :is-filter="true" :show-members="false" />
      </div>
      <div class="col-sm-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="addArtistChannelForm" type="default">추가</base-button>
          </div>
        </div>
      </div>
    </div>
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">아티스트 채널 관리</h4>
        </template>
        <div class="row">
          <el-table :data="data">
            <el-table-column :min-width="30" align="center" label="아이디">
              <div slot-scope="props">
                {{ props.row.contentChannelId }}
              </div>
            </el-table-column>
            <el-table-column :min-width="100" align="center" label="채널">
              <div slot-scope="props">
                <el-select class="select-primary" size="large" placeholder="채널선택" v-model="props.row.channelId">
                  <el-option v-for="option in channels" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
                </el-select>
              </div>
            </el-table-column>
            <el-table-column :min-width="50" align="right" label="삭제">
              <div slot-scope="props">
                <base-button @click.native="removeChannel(props)" type="warning" size="sm" icon>
                  <i class="tim-icons icon-simple-delete" />
                </base-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { Card } from "@/components/index";
import * as _ from "lodash";

export default {
  components: {
    ArtistSelect,
    Card,
  },
  async created() {
    await this.getChannels();
    await this.getData();
  },
  data() {
    return {
      unitId: null,
      data: [],
      channels: null,
    };
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      await this.getData();
    },
    async getChannels() {
      return this.$axios.get(`/common/contentChannels`).then((res) => {
        this.channels = res.data.data.map((d) => {
          return { label: d.name, value: d.id };
        });
      });
    },
    removeChannel(props) {
      this.data.splice(props.$index, 1);
    },
    addArtistChannelForm() {
      this.data.push({});
    },
    async getData() {
      this.data = [];
      return this.$axios.get(`/common/contentChannels`, { params: { unitId: this.unitId } }).then((res) => {
        const data = res.data.data;
        if (data) {
          this.data = data.map((d) => {
            return { channelId: d.id, contentChannelId: d.contentChannelId };
          });
        }
      });
    },

    async onSubmit() {
      if (!this.unitId) {
        window.Toast.error("잘못된 접근입니다.");
        return;
      }
      const channelIds = this.data.map((d) => d.channelId);
      if (this.hasDuplicates(channelIds)) {
        window.Toast.error("중복된 채널이 존재합니다");
        return;
      }
      const param = {
        channels: this.data,
      };

      return this.$axios.post(`/radarContent/${this.unitId}/channels`, param).then((res) => {
        window.Toast.success("등록되었습니다");
      });
    },
    goBack() {
      history.go(-1);
    },
    hasDuplicates(a) {
      return _.uniq(a).length !== a.length;
    },
  },
};
</script>
<style scoped lang="scss">
.bootstrap-switch {
  margin: 6px;
}
</style>
